import { saveToStorage, formatPortfolioAns } from "./utilities";
import Formatter from "@rmlibrary/formatting";

const formatter = new Formatter();

function storePrintValues(
    imagename,
    answers,
    portfolioWorth,
    buyAndHold,
    investorType,
    defaultDisclosure,
    stayinginvestedDisclosure,
    deFormat,
    finalAmounts
) {
    saveToStorage("volatility", {
        imageSrc: "./common/images/print/volatility-scenarios/" + imagename + ".png",
        first: answers.first.toLowerCase().trim(),
        second: answers.second.toLowerCase().trim(),
        third: answers.third.toLowerCase().trim(),
        name: answers.name,
        chosenPortfolio: formatPortfolioAns(answers.chosenPortfolio),
        investmentAmount: formatter.formatCurrency(answers.investmentAmount),
        portfolioWorth,
        buyAndHold,
        investorType,
        defaultDisclosure,
        stayinginvestedDisclosure,
        graphValues: finalAmounts,
        deFormat
    });
}

export { storePrintValues };
